export default "__VITE_ASSET__CXOrMhoU__"